export var getItem = function (key, options) {
    if (options === void 0) { options = {}; }
    var raw = options.raw;
    var item;
    try {
        var value = window.localStorage.getItem(key);
        item = raw ? value : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) { }
    return item !== null && item !== void 0 ? item : null;
};
export var setItem = function (key, value, options) {
    if (options === void 0) { options = {}; }
    var raw = options.raw;
    try {
        var resultValue = !!raw ? String(value) : JSON.stringify(value);
        window.localStorage.setItem(key, resultValue);
    }
    catch (_a) { }
};
export var removeItem = function (key) {
    try {
        window.localStorage.removeItem(key);
    }
    catch (_a) { }
};
